import { defineNuxtRouteMiddleware, navigateTo } from '#app'
import { useMainStore } from '~/composables/store'
import { stripUserCenterBase, USER_CENTER_BASE_PATH } from '~/user-center/routes'
import { getToken, setToken } from '~/user-center/src/utils/auth'
import {
  COLLECTION_USER_CENTER_HOME_PATH,
  getStoredStoreInformation,
  getStoreInfoDataMapValues,
  getUserCenterRedirectMapStoreInfoList,
  isCollectionUserCenterStoreInfoList,
  isExternalRedirectPath,
  MALL_USER_CENTER_HOME_PATH,
  resolveUserCenterRedirectPath,
} from '~/utils/collectionUserCenter'
import { setMallAppToken } from '~/utils/globalData'

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) {
    return
  }

  if (!to.path.startsWith(USER_CENTER_BASE_PATH)) {
    return
  }

  const nextJyToken = typeof to.query.setJyToken === 'string'
    ? to.query.setJyToken
    : Array.isArray(to.query.setJyToken)
      ? to.query.setJyToken[0]
      : ''
  const nextMallToken = typeof to.query.setMallToken === 'string'
    ? to.query.setMallToken
    : Array.isArray(to.query.setMallToken)
      ? to.query.setMallToken[0]
      : ''

  if (nextJyToken) {
    setToken(nextJyToken)
  }

  if (nextMallToken) {
    setMallAppToken(nextMallToken)
  }

  const hasToken = Boolean(getToken())
  const requiresAuth = to.meta.requiresUserCenterAuth !== false
  const mainStore = useMainStore()
  const storeInfoList = [
    ...getStoreInfoDataMapValues(mainStore.storeInfoDataMap),
    getStoredStoreInformation(),
  ]
  const redirectPath = resolveUserCenterRedirectPath(
    getUserCenterRedirectMapStoreInfoList(storeInfoList),
    to.fullPath,
    USER_CENTER_BASE_PATH,
  )

  if (redirectPath) {
    return navigateTo(redirectPath, {
      external: isExternalRedirectPath(redirectPath),
      replace: true,
    })
  }

  const isCollectionUserCenter = isCollectionUserCenterStoreInfoList(storeInfoList)
  const userCenterHomePath = isCollectionUserCenter
    ? `${USER_CENTER_BASE_PATH}${COLLECTION_USER_CENTER_HOME_PATH}`
    : `${USER_CENTER_BASE_PATH}${MALL_USER_CENTER_HOME_PATH}`

  if (!hasToken && requiresAuth) {
    const redirect = stripUserCenterBase(to.fullPath) || MALL_USER_CENTER_HOME_PATH
    return navigateTo(
      `${USER_CENTER_BASE_PATH}/login?redirect=${encodeURIComponent(redirect)}`,
      { replace: true },
    )
  }

  if (hasToken && isCollectionUserCenter && to.path === `${USER_CENTER_BASE_PATH}${MALL_USER_CENTER_HOME_PATH}`) {
    return navigateTo(`${USER_CENTER_BASE_PATH}${COLLECTION_USER_CENTER_HOME_PATH}`, { replace: true })
  }

  if (hasToken && to.path === `${USER_CENTER_BASE_PATH}/login`) {
    return navigateTo(userCenterHomePath, { replace: true })
  }
})
